import { render, staticRenderFns } from "./LaserSoftware.vue?vue&type=template&id=4bc22b98&scoped=true"
import script from "./LaserSoftware.vue?vue&type=script&lang=js"
export * from "./LaserSoftware.vue?vue&type=script&lang=js"
import style0 from "./LaserSoftware.vue?vue&type=style&index=0&id=4bc22b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc22b98",
  null
  
)

export default component.exports